import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { useAuthStore } from './store/auth.store';

async function bootstrap() {
  // 🔥 Restore session BEFORE rendering the app
  await useAuthStore.getState().initAuth();

  ReactDOM.render(
    <HelmetProvider>
      <SidebarProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SidebarProvider>
    </HelmetProvider>,
    document.getElementById('root')
  );
}

bootstrap();

serviceWorker.unregister();
